let youbi = ["SUN","MON", "TUE", "WED", "THU", "FRI", "SAT"];
let programs = [
	"ZAPPA",
	"TOKYO MORNING RADIO",
	"STEP ONE",
	"GOOD NEIGHBORS",
	"GROOVE LINE",
	"JAM THE WORLD",
	"SONAR MUSIC",
	"SPARK",
	"THE KINGS PLACE",
	"TOKYO M.A.A.D SPIN"
]
let t = {
	y: 0,
	m: 0,
	d: 0,
	h: 0,
	m: 0,
	data: 0
}
var thisweek = {
	xmlName: "",
	beforeSongTime: "",
	beforeChannelTime: "",
	selectDate: [],
	isFirst: true,
	date: 0,
	youbi: "",
	init: function(){
		//今日の日付
		let today 	= new Date();
		//let today = new Date(2020,3,4,1,55);
		console.log(today)
		t.data = today;
		t.y = today.getFullYear();
		t.m = today.getMonth()+1;
		t.d = today.getDate();
		t.h = today.getHours();
		t.min = today.getMinutes();
		thisweek.makeSelector();
		this.checkURL();
	},
	getYoubi: function(y, title){
		let thisYoubi = "";
		if(y === "Monday"){
			thisYoubi = "MON";
		}else if(y === "Tuesday"){
			thisYoubi = "TUE";
		}else if(y === "Wednesday"){
			thisYoubi = "WED";
		}else if(y === "Thursday"){
			thisYoubi = "THU";
		}else if(y === "Friday"){
			thisYoubi = "FRI";
		}else if(y === "Saturday"){
			thisYoubi = "SAT";
		}else if(y === "Sunday"){
			thisYoubi = "SUN";
		}
		for(var i = 0; i < programs.length; i++){
			if(title === programs[i]){
				if(title === "ZAPPA"){
					thisYoubi = "EVERYDAY";
				}else if(title === "TOKYO M.A.A.D SPIN"){
					thisYoubi = "EVERY MON-SAT";
				}else{
					thisYoubi = "EVERY MON-THU";
				}
			}
		}
		thisYoubi = "[" + thisYoubi + "]"
		return thisYoubi;
	},
	makeSelector: function(){
		let selectHTML = '';
		
		
		for(var i = -7; i < 7; i++){
			var setnow = new Date(t.y, t.m-1, t.d);
			setnow.setDate(setnow.getDate()+i);
			let y = setnow.getFullYear();
			let m = setnow.getMonth()+1;
			let d = setnow.getDate();
			let w = setnow.getDay();
			let sy = String(y);

			let txt = y + "/" + ( '00' + m ).slice( -2 ) + "/" + ( '00' + d ).slice( -2 ) + '（' + youbi[w] + '）';
			let val = sy[2] + sy[3] + ( '00' + m ).slice( -2 ) + ( '00' + d ).slice( -2 );
			if(i === 0){
				selectHTML += '<option id="today" value="' + val + '" data-y="' + y + '" data-m="' + m + '" data-d="' + d + '" data-w="' + w + '" selected="">' + txt + '</option>';
			}else{
				selectHTML += '<option value="' + val + '" data-y="' + y + '" data-m="' + m + '" data-d="' + d + '" data-w="' + w + '">' + txt + '</option>';
			}
		}
		$(".select select").html(selectHTML);

		$(".select select").off().on("change", function(){
			let val = $(this).val();
			let path = location.pathname + "?date=" + val;
			thisweek.selectDate[0] = $(":selected",this).attr("data-y");
			thisweek.selectDate[1] = $(":selected",this).attr("data-m");
			thisweek.selectDate[2] = $(":selected",this).attr("data-d");

			window.history.pushState(null, null, path);
			thisweek.checkURL();
		});
		$("a.btn_today").off().on("click", function(){
			if( !$(this).hasClass("disable") ){
				let path = location.pathname;
				window.history.pushState(null, null, path);
				thisweek.checkURL();
			}
		});
		let start 	= $(".select select option").eq(0).text();
		let end 	= $(".select select option:last").attr("data-m") + "/" + $(".select select option:last").attr("data-d") + '（' + youbi[$(".select select option:last").attr("data-w")] + '）';

		$(".txt_select .start").html(start);
		$(".txt_select .end").html(end);
	},
	makeContent: function(data){
		let afterCount 		= 0;
		let isFuture 		= false;
		let beforeIsChild 	= false;
		let today 			= new Date(2020,4,1,0,0);
		let current 		= today.getTime();
		var todayHTML 		= '';
		var tw = thisweek;
		$(data).find("item").each(function(i){
			let $this 		= $(this);
			let isParent 	= parseInt( $this.find("parents").text() );
			let title 		= $this.find("p_name").text();
			let email 		= $this.find("email").text();

			let thisTime 		= $this.find("time").text(),
				timeArry 		= thisTime.split("-");
			var startTimeArry 	= timeArry[0].split(":");
			var startTime 		= "";

			if(startTimeArry[0].length === 1){
				startTime = "0" + startTimeArry[0] + ":" + startTimeArry[1];
			}else{
				startTime = startTimeArry[0] + ":" + startTimeArry[1];
			}

			var endTimeArry = timeArry[1].split(":");
			var endTime = "";
			if(endTimeArry[0].length === 1){
				endTime = "0" + endTimeArry[0] + ":" + endTimeArry[1];
			}else{
				endTime = endTimeArry[0] + ":" + endTimeArry[1];
			}
			//console.log(startTime)
			let timeHTML = '<span class="s">' + startTime + '</span><span class="e">' + endTime + '</span>';
			
			//navigator
			let navigators = $this.find("navigator").text();
			let nArry = navigators.split("/");
			let nHTML = '';
			for(var i = 0; i < nArry.length; i++){
				nHTML += '<li>' + nArry[i].replace(" ", "") + '</li>'
			}
			//SNS
			let twURL 		= $this.find("twitter").text();
			let fbURL 		= $this.find("facebook").text();
			let instaURL 	= $this.find("instagram").text();
			let twHash 		= $this.find("twitter_hash").text();
			let snsHTML 	= thisweek.makeSNS(twURL, fbURL, instaURL, twHash);
			
			//-
			let timeFree 		= $this.find("timefree");
			let timeFreeHTML 	= '';
			let isInTime 		= false;
			if( $this.find("separated_url").length > 0){
				$this.find("separated_url").each(function(t){
					let s 			= $(this).attr("start");
					let ssplit 		= s.split(":");
					let attrEnd 	= $(this).attr("end");
					let esplit 		= attrEnd.split(':');
					if( parseInt( ssplit[0] ) >= 24 ){
						var setnow = new Date(tw.selectDate[0], tw.selectDate[1]-1, tw.selectDate[2]);
						setnow.setDate(setnow.getDate()+1);
						let n = parseInt( ssplit[0] ) - 24;
						var start 		= setnow.getFullYear() + "/" + parseInt( setnow.getMonth() +1) + "/" + ( '00' + setnow.getDate() ).slice( -2 ) + " " + ( '00' + n ).slice( -2 ) + ":" + esplit[1];
						var startDate 	= new Date(start).getTime();
						//console.log("start:", setnow, start, startDate)
					}else{
						var start 		= tw.selectDate[0] + "/" + tw.selectDate[1] + "/" + tw.selectDate[2] + " " + s;
						var startDate 	= new Date(start).getTime();
					}
					
					if( parseInt( esplit[0]) >= 24 ){
						let setnow = new Date(tw.selectDate[0], tw.selectDate[1]-1, tw.selectDate[2]);
						setnow.setDate(setnow.getDate()+1);
						let n = parseInt( esplit[0] ) - 24;
						var end 	= setnow.getFullYear() + "/" + parseInt( setnow.getMonth()+1 ) + "/" + setnow.getDate() + " " + ( '00' + n ).slice( -2 ) + ":" + esplit[1];
						var endDate = new Date(end).getTime();
						//console.log('end:',n, setnow, end, endDate)
					}else{
						var end 	= tw.selectDate[0] + "/" + tw.selectDate[1] + "/" + tw.selectDate[2] + " " + attrEnd;
						var endDate = new Date(end).getTime();
					}
					if(current >= startDate && current < endDate || endDate < current){
						isInTime = true;
						if(t === 0){
							timeFreeHTML += '<div class="time_free"><h4>TIME FREE</h4><ul>';
						}
						timeFreeHTML += '<li><a href="http://radiko.jp/share/?sid=FMJ&t=' + $(this).text() + '" title="part' + (t+1) + '" target="_blank" rel="noopener">'
									+	'<dl>'
									+	'<dt>part' + (t+1) + '</dt>'
									+	'<dd>' + $(this).attr("start") + ' - ' + $(this).attr("end") + '</dd>'
									+	'</dl></a></li>';
					}
				});
				if(isInTime){
					timeFreeHTML += '</ul></div>';
				}
			}
			
			let guestHTML = '';
			let guest = $this.find("guest").text();
			if(guest != ""){
				guestHTML = '<dl><dt>GUEST</dt><dd>' + guest + '</dd></dl>'
			}
			//console.log(snsHTML);
			let emailHTML = "";
			if(email != ""){
				emailHTML = '<a class="btn_message" href="mailto: ' + email + '" title="MESSAGE TO STUDIO"><span class="icon_mail">MESSAGE TO STUDIO</span></a>';
			}
			var ttlh3 = '<h3><a href="' + $this.find("link").text() + '" target="_blank">' + title + '</a></h3>'
			let onairYoubi = thisweek.getYoubi($this.find("week").text() ,title);
			//console.log(i, ttlh3)
			let channelHeader 	= '<div class="time"><p>' + timeHTML + '</p></div>'
								+ '<div class="channel_content content">'
								+ '<div class="channel_content_inner">'
								+ '<p class="onair"><span>NOW ON AIR</span></p>'
								+ '<div class="sns"><ul>' + snsHTML + '</ul></div>'
								+ '<div class="ttl_channel">'
								+ ttlh3
								+ '<div class="date"><p>' + onairYoubi + '</p></div>'
								+ '<ul class="navigator">' + nHTML + '</ul>'
								+ guestHTML
								+ '</div>'
			let channelCol2 = '<div class="channel_col2">'
							+ '<div class="col_l">'
							+ '<div class="img"><figure style="background-image: url(' + $this.find("main_photo").text() + ')"></figure></div>'
							+ '<a class="btn_channel_hp" href="' + $this.find("link").text() + '" title="番組HP" target="_blank"><p>番組<span>HP</span></p></a>'
							+ '<a class="btn_live" href="http://radiko.jp/#!/live/FMJ" onClick="thisweek.clickRadikoButton();"><span>LISTEN LIVE</span></a>'
							+ timeFreeHTML
							+ emailHTML
							+ '</div>'
							+ '<div class="col_r">'
							+ '<h4>' + $this.find("title").text() + '</h4>'
							+ '<p>' + $this.find("comment").text() + '</p>'
							+ '</div>'
							+ '</div>'
							+ '</div>';
			
			let sTime 	= timeArry[0],
				eTime 	= timeArry[1],
				sTimeS 	= sTime.split(":"),
				sTimeE 	= eTime.split(":");

			//各ブロックに日付を付与
			if( parseInt( sTimeS[0] ) >= 24 && sTimeS[0] <= 29 ){
				var setnow02 = new Date(tw.selectDate[0], tw.selectDate[1]-1, tw.selectDate[2]);
				setnow02.setDate(setnow02.getDate()+1);
				let n = parseInt( sTimeS[0] ) - 24;
				var start 		= setnow02.getFullYear() + "/" + (setnow02.getMonth()+1) + "/" + setnow02.getDate()+ " " + ( '00' + n ).slice( -2 ) + ":" + sTimeS[1];
				var startDate 	= new Date(start).getTime();
			}else{
				var start 		= tw.selectDate[0] + "/" + tw.selectDate[1] + "/" + tw.selectDate[2] + " " + sTime;
				var startDate 	= new Date(start).getTime();
			}
			//XMLのデータが統一されてないため、29時が5時になってしまうので、チェックして修正
			let missData = parseInt( sTimeE[0] );
			//console.log( missData )
			if(missData > 0 && missData <= 5){
				sTimeE[0] = parseInt(missData + 24);
			}
			if( parseInt( sTimeE[0]) >= 24 ){
				let setnow02 = new Date(tw.selectDate[0], tw.selectDate[1]-1, tw.selectDate[2]);
				setnow02.setDate(setnow02.getDate()+1);
				let n 		= sTimeE[0] - 24;
				var end 	= setnow02.getFullYear() + "/" + (setnow02.getMonth()+1) + "/" + setnow02.getDate() + " " + ( '00' + n ).slice( -2 ) + ":" + sTimeE[1];
				var endDate = new Date(end).getTime();
				//console.log(n, end, endDate)
			}else{
				var end 	= tw.selectDate[0] + "/" + tw.selectDate[1] + "/" + tw.selectDate[2] + " " + eTime;
				var endDate = new Date(end).getTime();
			}
			//thisweek.youbi = youbi[today.getDay()];
			if(isParent === 2){
				if(beforeIsChild){
					todayHTML += '</div>';
				}
				todayHTML 	+= '<div class="row" data-start="' + startDate + '" data-end="' + endDate + '">'
							+ channelHeader
							+ channelCol2
							+ '</div>';
				beforeIsChild = false;
			}else if(isParent === 1){
				var snsBlock = "";
				if(snsHTML != ""){
					var snsBlock = '<div class="sns"><ul>' + snsHTML + '</ul></div>';
				}
				let onairYoubi = thisweek.getYoubi($this.find("week").text() ,title);
				todayHTML 	+= '<div class="channel_content_child content">'
							+ '<div class="channel_content_inner">'
							+ '<div class="child_header">'
							+ '<p class="child_time">' + timeHTML + '</p>'
							+ snsBlock
							+ '</div>'
							+ '<div class="ttl_channel">'
							+ '<h3>' + title + '</h3>'
							//+ '<div class="date"><p>' + onairYoubi + '</p></div>'
							+ '<ul class="navigator">' + nHTML + '</ul>'
							+ guestHTML
							+ '</div>'
							+ channelCol2
							+ '</div>';
				beforeIsChild = true;
			}else{
				if(beforeIsChild){
					todayHTML += '</div>';
				}
				//通常
				todayHTML 	+= '<div class="row" data-start="' + startDate + '" data-end="' + endDate + '">'
							+ channelHeader
							+ channelCol2
							+ '</div>'
							+ '</div>';
				beforeIsChild = false;
			}
		});
		todayHTML += '</div>'
		$("#channels .section_inner").html(todayHTML);

		let currentH 	= t.data.getHours();
		let currentTime = 0;
		let todayDate 	= t.data.getDate();

		if( currentH >= 0 && currentH < 6 ){
			todayDate = parseInt( todayDate );
			currentTime =  ('00' + todayDate).slice( -2 );
		}else{
			currentTime =  ('00' + todayDate).slice( -2 );
		}
		let txtYoubi = youbi[$(".select option:selected").attr("data-w")];
		$(".row").eq(0).find(".ttl_channel h3 a").append("[" + txtYoubi + "]");
		//console.log(todayyoubi, youbi[todayyoubi]);
		if(parseInt( thisweek.selectDate[2] ) === parseInt( currentTime ) ){
			thisweek.checkCurrent(currentTime);

			setTimeout(function(){
				thisweek.moveToPosition();
			}, 600);
			$("a.btn_today").addClass("disable");
		}else{
			$("a.btn_today").removeClass("disable");
		}
		
		setTimeout(function(){
			$("#thisweek").removeClass("disable");
		}, 200);
	},
	makeSNS: function(twURL, fbURL, instaURL, twHash){
		let snsHTML = '';
		if( fbURL != "" ){
			snsHTML += '<li class="sns_fb"><a href="https://www.facebook.com/' + fbURL + '" title="facebook" target="_blank" rel="noopener"><svg class="icon_style"><use xlink:href="/assets_v2020/images/common/svg/symbol-defs.svg#icon_facebook"></use></svg></a></li>'
		}
		if( instaURL != "" ){
			snsHTML += '<li class="sns_insta"><a href="https://www.instagram.com/' + instaURL + '/" title="instagram" target="_blank" rel="noopener"><svg class="icon_style"><use xlink:href="/assets_v2020/images/common/svg/symbol-defs.svg#icon_instagram"></use></svg></a></li>'
		}
		if( twURL != "" ){
			snsHTML += '<li class="sns_tw"><a href="https://twitter.com/' + twURL + '" title="twitter" target="_blank" rel="noopener"><svg class="icon_style"><use xlink:href="/assets_v2020/images/common/svg/symbol-defs.svg#icon_twitter"></use></svg></a></li>'
		}
		if( twHash != "" ){
			snsHTML += '<li class="hash"><a href="https://twitter.com/search?q=%23' + twHash.replace("#", "") + '" title="" target="_blank" rel="noopener"><span>' + twHash + '</span></a></li>'
		}
		return snsHTML;
	},
	checkCurrent: function(todayDate){
		//ここの仕組みがどうなってるのか✔する
		//月をまたいだ時におかしくなる可能性アリなので。
		let d 		= t.data,
			year 	= d.getFullYear(),
			month 	= d.getMonth() + 1,
			day 	= todayDate;
		var today 	= year + "/" + month + "/" + day + " " + t.h + ":" + t.min;
		var current = new Date(today)

		if(t.h > 0 && t.h < 5){
			var setNextDate = new Date(year + "/" + month + "/" + day + " " + t.h + ":" + t.min);
			setNextDate.setDate(setNextDate.getDate()+1);
			let ddd = new Date(setNextDate);
			current = ddd.getTime();
			//console.log(ddd, current)
		}else{
			current = current.getTime();
		}
		$(".row").each(function(i){
			let $this 	= $(this);
			let start 	= parseInt( $(this).attr("data-start") );
			//let end 	= parseInt($(this).attr("data-end") );
			if(i < $(".row").length-2){
				var end = $(".row").eq(i+1).attr("data-start");
				end = parseInt(end);
			}else{
				var end 	= parseInt($(this).attr("data-end") );
			}
			//console.log(start, end)
			/*if(current >= start){
				console.log(end - current)
			}*/
			start = start;
			if(current > start && current < end){
				$this.addClass("current_onair");
			}
		});
	},
	clickRadikoButton: function(){
		JWAVE.Gigya.NotifyAction({action_id:"action_radiko_button"});
		gtag('event', 'Link', {'event_category': 'radiko','event_label': 'radiko_link'})
		return true;
	},
	loadXML: function(){
		if(!thisweek.isFirst){
			$("main#thisweek").addClass("disable");
		}else{
			thisweek.isFirst = false;
		}

		setTimeout(function(){
			common.scrollToPosition(0, 300);
			if( thisweek.xmlName != "" ){
				var xmlName = thisweek.xmlName;
			}

			let todayXML = "/epg/program/" + xmlName + ".xml";
			let params = {};
			let todayHTML = '';
			let today = new Date();
			let current = today.getTime();

			//console.log(current);
			thisweek.getXML(todayXML, params).done(function(data){
				thisweek.makeContent(data);
			});
		},600);
	},
	getXML: function(url, params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type: "GET",
			dataType: 'xml',
			url: url,
			data: params,
			success	: defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	},
	moveToPosition: function(){
		let d 		= t.data,
			current = d.getTime();
		//console.log("move to position")
		
		if( $html.classList.contains("fix_select") ){
			$html.classList.add("fix_select");
		}
		setTimeout(function(){
			let posY = $(".row.current_onair").offset().top - $("header").outerHeight() - $("#select_date").outerHeight();
			console.log(posY)
			common.scrollToPosition(posY, 1000);
		},100);
	},
	checkURL: function(){
		let param 	= location.search.substring(1);
		let pair 	= param.split('&');
		let hasParam = false;
		for(var i = 0; pair[i]; i++) {
			var kv = pair[i].split('=');
			if(kv[0] === "date"){
				thisweek.xmlName = kv[1];
				hasParam = true;
				$("a.btn_today").removeClass("disable");
				let strDay = String(kv[1]);

				thisweek.selectDate[0] = "20" + strDay[0] + strDay[1];
				thisweek.selectDate[1] = strDay[2] + strDay[3];
				thisweek.selectDate[2] = strDay[4] + strDay[5];
				//let daystring = "20" + strDay[0] + strDay[1] + "/" + strDay[2] + strDay[3] + "/" + strDay[4] + strDay[5];
				//let td = new Date(daystring);
				//let td_youbi = td.getDay();
				//thisweek.youbi = youbi[td_youbi];
				//console.log(thisweek.youbi);
				
				thisweek.loadXML();
			}
		}
		if(!hasParam){
			let today = t.data;
			thisweek.selectDate[0] = t.y;
			thisweek.selectDate[1] = ( '00' + t.m ).slice( -2 );
			thisweek.selectDate[2] = ( '00' + t.d ).slice( -2 );
			
			//thisweek.youbi = youbi[today.getDay()];
			//console.log(thisweek.youbi);
			let year 	= String( today.getFullYear() );
			let hour 	= today.getHours();
			let min 	= today.getMinutes();

			if(hour >= 0 && hour < 5){
				let date = (thisweek.selectDate[2] - 1);
				if(date === 0){
					var now = new Date(t.y, t.m-1, t.d);
					now.setDate(now.getDate()-1);
					var month = now.getMonth()+1;
					month =  ( '00' + month ).slice( -2 );
					date = now.getDate();
					//console.log(month, date)
				}else{
					var now = new Date(t.y, t.m-1, t.d);
					now.setDate(now.getDate()-1);
					var month = now.getMonth()+1;
					month 	= ( '00' + month ).slice( -2 );
					date 	= ( '00' + now.getDate() ).slice( -2 );
				}
				thisweek.selectDate[1] = parseInt( month );
				thisweek.selectDate[2] = date;
				t.data 	= new Date(now);
				t.m 	= month;
				t.d 	= date;
				//console.log(t.m, t.d)
				thisweek.xmlName = year[0] + year[1] + String(month) + String( date );
				//console.log(thisweek.xmlName)
				//console.log(thisweek.xmlName, "こっち")
			}else{
				thisweek.date = thisweek.selectDate[2];
				thisweek.xmlName = year[0] + year[1] + String( thisweek.selectDate[1] ) + String( thisweek.selectDate[2] );
			}
			thisweek.loadXML();
		}
		$(".select select option").prop("selected", "");
		$(".select select option").each(function(){
			let val = $(this).val();
			let $this = $(this);
			if(val === thisweek.xmlName){
				$this.prop("selected", "selected");
			}
		});
	}
}
